import { render } from "./PwaModal.vue?vue&type=template&id=d0410b6c"
import script from "./PwaModal.vue?vue&type=script&lang=js"
export * from "./PwaModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__